<template>
  <div class="randevu-container">
    <RandevuHeader />

    <AdvancedMenu /> 
     
  </div>
</template>

<script>
import RandevuHeader from './RandevuHeader.vue';

import AdvancedMenu from './AdvancedMenu.vue';  

export default {
  components: {
    RandevuHeader, 
    AdvancedMenu 
  }
};
</script>


<style scoped>
.randevu-container {
  padding-top: 120px; 
}

.advanced-menu { 
  display: flex;
  flex-direction: column;  
  justify-content: center; 
  align-items: center;
}

.advanced-menu-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  max-width: 1080px;
  margin: 1rem;
}

.switch {
  width: 46px;
  height: 24px;
  background: #2a3942;
  border-radius: 12px;
  position: relative;
  cursor: pointer;
  transition: background 0.3s;
}

.switch .circle {
  width: 20px;
  height: 20px;
  background: #cacaca;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  left: 2px;
  transition: all 0.3s;
}

.switch.active {
  background: #106e35;
}

.switch.active .circle {
  transform: translateX(22px);
}

.label {
  margin-right: 10px;
  font-size: 0.9rem;
  color: #ccc;
}

@media (max-width: 768px) {
  .randevu-container {
    padding-top: 90px;
  }
}
</style>
